<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class='col-md-12 text-center'>
                <img src="../../public/mineimages/access.png"/>
            </div>
            <div class='offset-md-2 col-md-8 text-center'>
                <v-alert
                        border="left"
                        color="orange"
                        dark
                >
                    Vous n'avez pas la permission requise pour accéder à cette fonctionnalité. Veuillez contacter votre
                    administrateur.
                </v-alert>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Permission",
        data() {

        },
        computed: {},
        mounted() {

        }
    }
</script>

<style scoped>
    .nav-link {
        color: #2A3042;
        font-weight: bold;
    }

</style>